import BaseNavbar from './utils/navbar';
import Dashboard from './pages/dashboard';
import {useDispatch, useSelector} from 'react-redux';
import React, {useEffect} from 'react';
import DashboardsService from './store/dashboards/service';
import TokensService from './store/token/service';
import {Toaster} from 'react-hot-toast';
import Communication from './communication';
import config from './config';
import Login from './pages/auth';

function App() {
    const dispatch = useDispatch();
    const dashboardsData = useSelector((state) => state.dashboardsData);

    useEffect(() => {
        DashboardsService.loadDashboards(dispatch, {});
        TokensService.loadDashboards(dispatch, {});
    }, [dispatch])

    useEffect(() => {
        const accessRefresh = localStorage.getItem('refresh')

        Communication.getMethod(
            config.endPoints.status,
            {}
        ).then(response => {
            dispatch({
                type: 'MAKE_LOGIN'
            })
        }).catch((response) => {
            if (response.response.status === 403 && accessRefresh !== "undefined") {
                Communication.postMethod(
                    config.endPoints.login_refresh,
                    {"refresh": accessRefresh}
                ).then(refresh_response => {
                    localStorage.setItem('token', response['access']);
                    dispatch({
                        type: 'MAKE_LOGIN'
                    })
                }).catch((refresh_response) => {
                    console.log(refresh_response)
                }).finally(() => {
                })
            }
        }).finally(() => {
        })
    }, [])

    return (
        <>
            <Toaster
                position="top-left"
                reverseOrder={false}
            />
            {dashboardsData['is_login'] ? (
                <>
                    <BaseNavbar/>
                    <Dashboard/>
                </>
            ) : (
                <Login/>
            )}
        </>
    );
}

export default App;
